// Mockup view for admin
const AdminMockupView = () => {
  return <div className="mm-pod-section-auto p-2"></div>;
};

export default AdminMockupView;
